<!-- @format -->

@if (errorMessage()) {
	@if (errorMessageDisplayable()) {
		<span class="hmf-body-bold-m hmf-display-flex hmf-align-items-start label-negative">
			<homefield-icon
				width="20px"
				height="20px"
				fill="currentColor"
				name="alert-info-filled"
				class="hmf-display-flex"
			></homefield-icon>
			<span class="hmf-ml-xxs">{{ errorMessage() }}</span>
		</span>
	}
} @else {
	<span class="hmf-header-bold-xs hmf-text-transform-none">{{ attributeGroupName() }}: </span>
	@if (selectedAttributeValueDisplayable()) {
		<span class="hmf-header-xs hmf-text-transform-none">{{ selectedAttributeValue() }}</span>
	}
}
